<div
	class="dropdown-host text-content"
	(click)="openDialog()"
	(mouseenter)="isHovered.set(true)"
	(mouseleave)="isHovered.set(false)"
	[class.active]="showDropdown()"
	[class.disabled]="!enabled()"
	[attr.aria-label]="label()"
	#dropdownHost
>
	@if (selectedOptie) {
		<div class="content">{{ selectedOptie.text }}</div>
	} @else {
		<div class="placeholder">{{ placeholder }}</div>
	}
	<app-icon [name]="iconName()" size="small" [color]="iconColor()"></app-icon>
</div>
